// extracted by mini-css-extract-plugin
export default {"lockingContentWrapper":"LockingTimerComponent__lockingContentWrapper___nYttU"};